export function isObject(o) {
    return o instanceof Object && o.constructor === Object;
}

export function titleCase(str) {
    var splitStr = str.toLowerCase().split(' ');
    for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
    }
    // Directly return the joined string
    return splitStr.join(' ');
}

export function hasKey(obj, key) {
    var proto = obj.__proto__ || obj.constructor.prototype;

    return key in obj && (!(key in proto) || proto[key] !== obj[key]);
}

export const delay = ms => new Promise(res => setTimeout(res, ms));

export const formattedCurrency = number => {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(number);
};
